import React, { useState, useEffect, Fragment } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Item from './Item';
import ItemAd from './ItemAd';
import { getQuery } from '@src/public/utils/url';
import CommentModal from '@src/mobile/components/EventCard/UnfoldCard/Footer/CommentModal';
import { Sheet } from '@src/mobile/components/ModalBox';

const EventList = ({ content, showType, allFold, changeAllFold = () => {} }) => {
    const { nodes, parties, timeline, list2Ad } = content;
    const isWarPage = content?.timeline?.id === '8r727OWpK5W';
    const vip = getQuery(window.location.href, 'vip');
    const isVip = !!(vip && vip !== '0');

    // 记录所有短内容收起展开状态的数组
    const [nodeFoldList, setNodeFoldList] = useState([]);

    // 根据单个短内容收起展开状态改变nodeFoldList和allFold
    const changeFold = (id, bool) => {
        // 获取nodeFoldList的当前项并改变值
        const newNodeFoldList = nodeFoldList.map(item => ({ id: item.id, fold: item.id === id ? bool : item.fold }));

        // 判断现在的全部收起展开状态
        const allNodeFold = !newNodeFoldList.find(item => item.fold === false);
        const allNodeUnfold = !newNodeFoldList.find(item => item.fold === true);
        let newAllFold = allFold;

        if (allNodeFold) {
            newAllFold = true;
        }

        if (allNodeUnfold) {
            newAllFold = false;
        }

        // 改变nodeFoldList和allFold
        setNodeFoldList(newNodeFoldList);
        changeAllFold(newAllFold);
    };

    useEffect(
        () => {
            const newNodeFoldList = nodes.map(item => {
                const { id } = item;
                const nodeFold = nodeFoldList.find(item => item.id === id);
                const fold = nodeFold ? nodeFold.fold : allFold;

                return { id, fold };
            });

            setNodeFoldList(newNodeFoldList);
        },
        [nodes],
    );

    useEffect(
        () => {
            const newNodeFoldList = nodeFoldList.map(item => ({ id: item.id, fold: allFold }));

            setNodeFoldList(newNodeFoldList);
        },
        [allFold],
    );

    const [scrollToNode, setScrollToNode] = useState(false);
    const [scrollToNodeId, setScrollToNodeId] = useState('');
    const changeScrollToNode = bool => {
        setScrollToNode(bool);
    };

    const [scrollToComment, setScrollToComment] = useState(false);
    const [scrollToCommentId, setScrollToCommentId] = useState('');

    const handleCloseComment = () => {
        setScrollToComment(false);
    };

    useEffect(() => {
        const msgSubjectId = getQuery(window.location.href, 'msgSubjectId');

        if (msgSubjectId && window.msgSubjectId !== msgSubjectId) {
            window.msgSubjectId = msgSubjectId;
            setScrollToNode(true);
            setScrollToNodeId(msgSubjectId);
        }
    }, []);

    useEffect(
        () => {
            if (scrollToNode) {
                const msgExtraId = getQuery(window.location.href, 'msgExtraId');

                if (msgExtraId && window.msgExtraId !== msgExtraId) {
                    window.msgExtraId = msgExtraId;
                    setScrollToComment(true);
                    setScrollToCommentId(msgExtraId);
                }
            }
        },
        [scrollToNode],
    );

    return (
        <>
            <div>
                {nodes && Array.isArray(nodes) && nodes.length
                    ? nodes.map((item, index) => {
                        return (
                            <Fragment key={item.id}>
                                {isWarPage && index === 1 && window.grounds && !isVip && <ItemAd content={list2Ad} />}
                                <Item
                                    content={item}
                                    showType={showType}
                                    allFold={allFold}
                                    parties={parties}
                                    timeline={timeline}
                                    changeFold={changeFold}
                                    index={index}
                                    scrollToNode={scrollToNode && scrollToNodeId === item.id}
                                    changeScrollToNode={changeScrollToNode}
                                />
                            </Fragment>
                        );
                    })
                : null}
            </div>
            <Sheet top={80} show={scrollToComment} onClose={handleCloseComment}>
                <CommentModal subjectId={scrollToNodeId} close={handleCloseComment} replyId={scrollToCommentId} />
            </Sheet>
        </>
    );
};

EventList.propTypes = {
    content: PropTypes.object,
    showType: PropTypes.string,
    allFold: PropTypes.bool,
    changeAllFold: PropTypes.func,
};

export default errorBoundary(EventList);
